import { render } from "./page-tree.vue?vue&type=template&id=0c1a2358&scoped=true"
import script from "./page-tree.vue?vue&type=script&lang=js"
export * from "./page-tree.vue?vue&type=script&lang=js"

import "./page-tree.vue?vue&type=style&index=0&id=0c1a2358&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-0c1a2358"

export default script